import FireIcon from './fire.svg'
import GrowIcon from './grow.svg'
import NotificationIcon from './notification.svg'

export const icons = {
  FireIcon,
  GrowIcon,
  NotificationIcon,
}
